import { Box, Stack } from '@mui/material';
import { CuboidToolbar } from './Cuboids';
import { CopyViewButton } from './CopyViewButton';

export const TopToolbar = () => {
  return (
    <Box sx={{ padding: '10px', minHeight: '80px' }}>
      <Stack direction="column" spacing={1}>
        <CuboidToolbar />
        <Box>
          <CopyViewButton />
        </Box>
      </Stack>
    </Box>
  );
};
